<template>
    <div>
    <v-card :loading="loading">
      <!-- Descrição -->
      <div>
        <h2>Descrição:</h2>
        <p class="text-justify">Selecione as competências comportamentais considerando que estão
          atribuidas diretamente ao cargo do colaborador, logo se quiser que o modelo
          avalie determinada classe de cargos escolha apenas as competências relacionadas.
        </p>
      </div>
      <!-- Competências -->
      <div>
        <v-autocomplete
          v-model="competenciasSelected"
          :items="competencias"
          outlined
          :deletable-chips="true"
          dense
          chips
          small-chips
          label="Competências"
          multiple
          @blur="exibirComportamentos()"
        >
          <template v-slot:selection="data">
            <template>
              <v-chip>
                <v-icon class="pr-3">{{ data.item.icone }}</v-icon>
                <v-list-item-content>
                  {{ data.item.nome }}
                </v-list-item-content>
              </v-chip>
            </template>
          </template>
          <template v-slot:item="data">
            <template>
              <v-icon class="pr-3">{{ data.item.icone }}</v-icon>
              <v-list-item-content>
                {{ data.item.nome }}
              </v-list-item-content>
            </template>
          </template>
        </v-autocomplete>
      </div>
      <div>
        <div class="mb-8">
          <h3 style="color: rgba(0, 0, 0, 0.54)">Previsualização</h3>
          <v-divider></v-divider>
        </div>
        <div>
          <div class="mb-4">
            <h4 style="color: rgba(0, 0, 0, 0.54)">
              Autoavaliação - Como você se avalia no comportamento:
            </h4>
            <v-card
              v-for="comportamento in comportamentosSelected" :key="comportamento.id"
              style="background-color: white !important"
              elevation="4"
              class="ma-2 pb-3"
            >
              <v-container>
                {{ comportamento.descricao }}
                <v-slider
                  class="mx-2"
                  hide-details
                  v-model="range"
                  disabled
                  step="1"
                  min="1"
                  max="10"
                  thumb-label
                  ticks
                  persistent-hint
                  track-color="orange darken-3"
                  :tick-labels="ticksLabels"
                ></v-slider>
              </v-container>
            </v-card>
          </div>
          <div class="mb-4">
            <h4 style="color: rgba(0, 0, 0, 0.54)">
              Avaliação de Pares - Como você avalia seu colega NOME no
              comportamento:
            </h4>
            <v-card
              v-for="comportamento in comportamentosSelected" :key="comportamento.id"
              style="background-color: white !important"
              elevation="4"
              class="ma-2 pb-3"
            >
              <v-container>
                {{ comportamento.descricao }}
                <v-slider
                  class="mx-2"
                  hide-details
                  v-model="range"
                  disabled
                  step="1"
                  min="1"
                  max="10"
                  thumb-label
                  ticks
                  persistent-hint
                  track-color="orange darken-3"
                  :tick-labels="ticksLabels"
                ></v-slider>
              </v-container>
            </v-card>
          </div>
          <div class="mb-4">
            <h4 style="color: rgba(0, 0, 0, 0.54)">
              Avaliação de Líder - Como você avalia seu líder NOME no
              comportamento:
            </h4>
            <v-card
              v-for="comportamento in comportamentosSelected" :key="comportamento.id"
              style="background-color: white !important"
              elevation="4"
              class="ma-2 pb-3"
            >
              <v-container>
                {{ comportamento.descricao }}
                <v-slider
                  class="mx-2"
                  hide-details
                  v-model="range"
                  disabled
                  step="1"
                  min="1"
                  max="10"
                  thumb-label
                  ticks
                  persistent-hint
                  track-color="orange darken-3"
                  :tick-labels="ticksLabels"
                ></v-slider>
              </v-container>
            </v-card>
          </div>
          <div class="mb-4">
            <h4 style="color: rgba(0, 0, 0, 0.54)">
              Avaliação de Cliente - Como você avalia seu cliente NOME
              no comportamento:
            </h4>
            <v-card
              v-for="comportamento in comportamentosSelected" :key="comportamento.id"
              style="background-color: white !important"
              elevation="4"
              class="ma-2 pb-3"
            >
              <v-container>
                {{ comportamento.descricao }}
                <v-slider
                  class="mx-2"
                  hide-details
                  v-model="range"
                  disabled
                  step="1"
                  min="1"
                  max="10"
                  thumb-label
                  ticks
                  persistent-hint
                  track-color="orange darken-3"
                  :tick-labels="ticksLabels"
                ></v-slider>
              </v-container>
            </v-card>
          </div>
          <div class="mb-4">
            <h4 style="color: rgba(0, 0, 0, 0.54)">
              Avaliação de Subordinados - Como você avalia seu
              subordinado NOME no comportamento:
            </h4>
            <v-card
              v-for="comportamento in comportamentosSelected" :key="comportamento.id"
              style="background-color: white !important"
              elevation="4"
              class="ma-2 pb-3"
            >
              <v-container>
                {{ comportamento.descricao }}
                <v-slider
                  class="mx-2"
                  hide-details
                  v-model="range"
                  disabled
                  step="1"
                  min="1"
                  max="10"
                  thumb-label
                  ticks
                  persistent-hint
                  track-color="orange darken-3"
                  :tick-labels="ticksLabels"
                ></v-slider>
              </v-container>
            </v-card>
          </div>
        </div>
      </div>
    </v-card>
    <!-- Botões de Continuar e Voltar -->
    <div class="d-flex flex-column flex-sm-row mt-10">
      <v-btn color="primary" @click="continuar()"> Continuar </v-btn>
      <v-btn text class="mx-3" @click="voltar()"> Voltar </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "AvdComportamental",
  data() {
    return {
      competenciasSelected: [],
      comportamentosSelected: [],
      range: 5,
      ticksLabels: [1,2,3,4,5,6,7,8,9,10]
    }
  },
  created() {
    if(this.competencias.length === 0) {
      this.$store.dispatch("avd/buscarAvdComportamental",this.$route.params.uuid);
    } 
    if(this.AvdComportamental.length > 0) {
      this.competenciasSelected = this.competenciasSelect;
      this.comportamentosSelected = this.AvdComportamental;
    }
  },
  computed: {
    AvdComportamental: {
      get() {
        return this.$store.getters["avd/getAvdComportamental"];
      },
      set(value) {
        return value;
      }
    },
    comportamentos: {
      get() {
        return this.$store.getters["avd/getComportamentosComportamentais"];
      }
    },
    competencias: {
      get() {
        return this.$store.getters["avd/getCompetenciasComportamentais"];
      }
    },
    competenciasSelect: {
      get() {
        return this.$store.getters["avd/getCompetenciasComportamentaisSelect"];
      },
      set(value) {
        return value;
      }
    },
    loading: {
      get() {
        return this.$store.getters["avd/getLoading"];
      },
      set(value) {
        return value;
      }
    },
  },
  methods: {
    exibirComportamentos() {
      this.comportamentosSelected = [];
      this.comportamentos.forEach(comportamento => {
        if(this.competenciasSelected.some(competencia => comportamento.competencia_select_id_nome_icone.id === competencia.id)) {
          this.comportamentosSelected.push(comportamento);
        }
      });
    },
    voltar() {
      this.$store.dispatch('avd/resetAvdComportamentalData')
      this.competenciasSelected.forEach(c => this.competenciasSelect.push(c))
      this.comportamentosSelected.forEach(c => this.AvdComportamental.push(c))
      this.$emit('decrease')
    },
    continuar() {
      this.$store.dispatch('avd/resetAvdComportamentalData')
      this.competenciasSelected.forEach(c => this.competenciasSelect.push(c))
      this.comportamentosSelected.forEach(c => this.AvdComportamental.push(c))
      this.$emit('count');
    }
  }
}
</script>

<style>

</style>